module.exports = __webpack_public_path__ + "img/hsbc2.5d19abcb.png";